/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import React from 'react'
import { Select } from 'antd'
const { Option, OptGroup } = Select

const CitySelectComponent = ({ cities, onChange, currentUserBranches, coyId, value, form }) => {
	// Job
	const handleChangeMultiple = (value) => {
		if (value.includes('select-all')) {
			value = cities.map(city => city.id)
		} else if (value.includes('unselect-all')) {
			value = []
		}

		onChange(value)
	}

	const handleChange = (value) => {
		form.setFieldsValue({ cityId: value })
	}

	// ['Johor', 'Kedar', ...]
	const distinctStates = [...new Set(cities.map(city => city.State.name))]

	const getSelectedCities = () => {
		const correspondingCoy = currentUserBranches.find(Branch => Branch.companyId === coyId)
		return correspondingCoy.selectedCities
	}

	return (
		<Select
			// onChange={typeof currentUserBranches !== 'undefined' ? handleChangeMultiple() : handleChange(value)}
			onChange={typeof currentUserBranches !== 'undefined' ? handleChangeMultiple : handleChange}
			placeholder='Select City'
			mode={typeof currentUserBranches !== 'undefined' ? 'multiple' : null}
			allowClear
			optionFilterProp='name'
			value={typeof currentUserBranches !== 'undefined' ? getSelectedCities() : value}
			showSearch
			maxTagCount={3}
		>
			{getSelectedCities(coyId).length !== cities.length && <Option value='select-all'>Select All</Option>}
			{getSelectedCities(coyId).length > 0 && <Option value='unselect-all'>Unselect All</Option>}
			{distinctStates.map((state,i) => {
				const filteredCities = cities.filter(city => city.State.name === state)
				return (
					<OptGroup label={state} key={i}>
						{filteredCities.map(city => <Option key={city.id} value={city.id} name={city.id + city.name}>{city.name}</Option>)}
					</OptGroup>
				)
			})}
		</Select>
	)
}

export default CitySelectComponent
